import { c as _c } from "react/compiler-runtime";
import { Badge, BadgeProps, Icon } from '@chakra-ui/react';
import { LuSparkles } from 'react-icons/lu';
export type AdvisorFeaturedBadgeProps = {
  /** `ScoAdvisorProfile.isFeatured` — unexpired Featured or VIP (L50). Renders nothing when falsy. */
  isFeatured?: boolean | null;
  size?: BadgeProps['size'];
};

/**
 * Public "Featured" label for Featured and VIP advisors (L50). One label for both tiers; the rank
 * score itself is never shown. The visible word is the accessible name (the icon is decorative).
 */
export const AdvisorFeaturedBadge = t0 => {
  const $ = _c(3);
  const {
    isFeatured,
    size: t1
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  if (!isFeatured) {
    return null;
  }
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon aria-hidden={true} boxSize="3"><LuSparkles /></Icon>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== size) {
    t3 = <Badge colorPalette="orange" data-testid="advisor-featured-badge" flexShrink={0} size={size} title="Featured advisor" variant="subtle">{t2}Featured</Badge>;
    $[1] = size;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};